<template>
  <b-modal
    id="modal-category"
    centered
    class="modal-category"
    :no-enforce-focus="true"
  >
    <div class="modal-category-itens">
      <div class="modal-category-itens-header">
        <button
          class="modal-category-itens-close"
          @click="$bvModal.hide('modal-category')"
        >
          <div class="modal-category-itens-close--icon">
            <img
              class="img-fluid"
              src="@/assets/img/close-modal.png"
              alt="icon close"
              title="icon close"
            />
          </div>
        </button>
      </div>
      <div class="modal-category-itens-body">
        <div class="modal-category--header">
          <h2>Nova Categoria</h2>
          <img
            class="img-fluid"
            src="@/assets/img/icon-add.png"
            alt="icon add"
            title="icon add"
          />
        </div>
        <form class="modal-category--form" @submit.prevent="handleSubmit()">
          <div class="content-input-default">
            <input
              type="text"
              name="name"
              v-model="category.name"
              value=""
              placeholder="Nome"
              required
            />
          </div>
          <div class="col-12" v-if="modalCategory?.isType === 'Blog'">
            <UploadImage @changePicture="handleChangePicture" />
          </div>
          <div class="modal-category-btns">
            <button type="submit" class="btn-green">Salvar</button>
          </div>
        </form>
      </div>
    </div>
  </b-modal>
</template>

<script>
import UploadImage from "@/components/upload/Index";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      category: {
        id_user: "",
        name: "",
      },
    };
  },
  components: {
    UploadImage,
  },
  computed: {
    ...mapGetters({ user: "User/user" }),
    ...mapGetters(["modalCategory"]),
  },
  watch: {
    modalCategory: {
      handler(newValue) {
        if (!newValue.data) {
          this.clearInput();
          this.setImageFileUrl(null);
          return;
        }

        let dataCategory = newValue.data;
        this.category = {
          id_user: dataCategory.id_user,
          name: dataCategory.name,
        };
        if (dataCategory?.picture) {
          this.setImageFileUrl(dataCategory.picture);
          this.convertToImageFile(dataCategory.picture);
        }
      },
    },
  },
  methods: {
    ...mapActions("Blog", ["registerCategoryBlog"]),
    ...mapActions("Ebooks", ["registerCategoryEbooks"]),
    ...mapActions("Plans", ["registerCategoryPlans"]),
    ...mapActions("Meditation", ["registerCategoryMeditation"]),
    ...mapActions(["setImageFileUrl"]),
    async handleSubmit() {
      this.category.id_user = await this.user.id;
      this.category.id = this.modalCategory?.data?.id;

      console.log("CATEGORY", this.category);

      if (this.modalCategory?.isType === "Blog") {
        await this.registerCategoryBlog(this.category);
      } else if (this.modalCategory?.isType === "Ebooks") {
        await this.registerCategoryEbooks(this.category);
      } else if (this.modalCategory?.isType === "Plans") {
        await this.registerCategoryPlans(this.category);
      } else if (this.modalCategory?.isType === "Meditation") {
        await this.registerCategoryMeditation(this.category);
      }

      let message = this.modalCategory?.data?.id
        ? "Categoria editada com sucesso!"
        : "Categoria cadastrada com sucesso!";
      if (!this.modalCategory?.data?.id) {
        this.clearInput();
      }
      this.$bvModal.hide("modal-category");
      this.$swal.fire({ icon: "success", html: message });
    },
    clearInput() {
      this.category.id_user = "";
      this.category.name = "";
    },
    convertToImageFile(url) {
      url = `data:image/jpg;base64,${url}`;

      // convert url image to blob
      fetch(url)
        .then((res) => res.blob())
        .then((data) => {
          this.category.picture = data;
        });
    },
    handleChangePicture(value) {
      this.category.picture = value;
    },
  },
};
</script>

<style lang="scss">
#modal-category {
  .modal-header,
  .modal-footer {
    display: none;
  }
  .modal-content {
    box-shadow: 0px 3px 16px rgba(0, 0, 0, 0.16);
    border: 0;
    border-radius: 20px;
  }
  .modal-body {
    padding: 0;
  }
}
.modal-category {
  &-itens {
    &-close {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      padding: 10px;
      border: 0;
      background: 0;
      transition: 500ms;
      &:hover,
      &:focus {
        cursor: pointer;
        opacity: 0.8;
      }
    }
    &-body {
      padding: 25px 20px 30px 20px;
      .modal-category {
        &--header {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 30px;
          h2 {
            font-size: 20px;
            font-family: "Font Light";
            color: var(--black);
            margin-bottom: 0;
          }
          img {
            max-width: 24px;
            margin-left: 10px;
          }
        }
        &-btns {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 100px;
        }
      }
      .text-not--image {
        position: absolute;
        left: 0;
        bottom: 0;
        font-size: 10px;
        font-family: "Font Light";
        color: var(--red);
        margin-bottom: 0;
      }
    }
  }
}
</style>
